import React, { useState } from "react";
import { Button, Modal } from "antd";

const AlertModal = (props: any) => {
  return (
    <div>
      <Modal
        title="Booking Unavailable"
        closable={{ "aria-label": "Custom Close Button" }}
        open={props?.open}
        // onOk={() => props?.close()}
        footer={null}
        onCancel={() => props?.close()}
      >
        <p>
          We are currently experiencing technical difficulties. We apologize for
          the inconvenience.
        </p>
        <Button type="primary" onClick={() => props?.close()}>
          Close
        </Button>
      </Modal>
    </div>
  );
};

export default AlertModal;
